import { atom } from 'jotai';
import type { RowSelectionState } from '@tanstack/react-table';
import { atomWithStorage } from 'jotai/utils';
import { atomFamily } from 'jotai-family';
import type { ContractReviewSeverity } from '@/features/contract-review/constants';
import type { UserReview } from '@/features/user-review/constants';
import type { FilterMode, ORDER_DIRECTIONS } from '@/filters';

export const runContractReviewOpenAtom = atom(false);

export const createContractReviewTemplateOpenAtom = atom(false);

export const contractReviewSearchAtom = atomFamily((_workspaceId: string) => atom(''));

export const contractReviewDomainSearchAtom = atomFamily((_domainPath: string) => atom(''));

export const contractReviewRowSelectionAtom = atomFamily((_workspaceId: string) =>
  atom<RowSelectionState>({}),
);

export const contractReviewDomainRowSelectionAtom = atom<RowSelectionState>({});

export const contractReviewFilterAtom = atomWithStorage<{
  priority?: ContractReviewSeverity[];
  priorityMode?: FilterMode;
  order?: { direction?: (typeof ORDER_DIRECTIONS)[number] };
}>('legal-deviations-filter', { order: { direction: 'desc' } });

export const contractReviewDomainFilterAtom = atomWithStorage<{
  severity?: ContractReviewSeverity[];
  severityMode?: FilterMode;
  userReview?: UserReview[];
  userReviewMode?: FilterMode;
  showNotRelevant?: boolean;
  order?: { direction?: (typeof ORDER_DIRECTIONS)[number]; field?: 'severity' | 'status' };
}>('legal-deviations-domain-filter', {
  order: { direction: 'desc', field: 'status' },
  showNotRelevant: false,
});

export const contractReviewClusterIdAtom = atom<string | null>(null);

export const contractReviewClusterPanelOpenAtom = atom(false);
